<template>
  <div>
    <div>
      <report-programacao
        id="printMe"
        v-show="false"
        :programacao="programacao"
        :pedido="pedido"
      />
      <div class="row">
        <div class="col-12">
          <q-card>
            <q-linear-progress v-if="loading" indeterminate color="primary" />
            <q-card-section class="text-right">
              <!-- <b-button class="float-right" @click="$refs.html2Pdf.generatePdf()" variant="primary" :disabled="!extrato.length">
                Imprimir
              </b-button> -->
              <q-btn
                label="Imprimir"
                icon="print"
                dense
                @click="print"
                color="primary"
                :disable="!programacao.length"
              />
            </q-card-section>
            <q-card-section>
              <q-table
                v-if="programacao.length"
                :loading="loading"
                dense
                class="my-sticky-virtscroll-table no-shadow"
                :data="programacao"
                :rows-per-page-options="[0]"
                virtual-scroll
                :virtual-scroll-sticky-size-start="48"
                :columns="columns"
              />
              <q-banner class="bg-orange text-white" v-if="!programacao.length && !loading">
                Nenhum resultado encontrado
              </q-banner>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportProgramacao from './ReportProgramacao'
import { getProgramacao } from '../../services/pedidos'
import moment from 'moment'

export default {
  name: 'grid-extrato',
  props: {
    pedido: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      programacao: [],
      columns: [
        { name: 'pedData', field: 'pedData', label: 'Data Pedido', format: value => moment(value).format('DD/MM/YYYY'), align: 'left' },
        { name: 'dataagenda', field: 'dataagenda', label: 'Data Agendamento', format: value => moment(value).format('DD/MM/YYYY'), align: 'left' },
        { name: 'prdDescricao', field: 'prdDescricao', label: 'Descrição', align: 'left' },
        { name: 'veiPlaca', field: 'veiPlaca', label: 'Placa Veículo', align: 'left' },
        { name: 'respCarga', field: 'respcarga', label: 'Transportadora', align: 'left' },
        { name: 'motorista', field: 'motorista', label: 'Motorista', align: 'left' },
        { name: 'pesoliquido', field: 'pesoliquido', label: 'Peso Líquido (ton)', align: 'right' },
        { name: 'situacao', field: 'situacao', label: 'Situação', align: 'center' },
      ],
      tableProgramacao: {
        fields: [
          { key: 'pedData', label: 'Data Pedido' },
          { key: 'dataagenda', label: 'Data Agendamento' },
          { key: 'prdDescricao', label: 'Descrição' },
          { key: 'veiPlaca', label: 'Placa Veículo' },
          { key: 'motorista', label: 'Motorista' },
          { key: 'respcarga', label: 'Resp. Carga' },
          { key: 'situacao', label: 'Situação' },
        ]
      }
    }
  },
  mounted () {
    this.getProgramacao()
  },
  methods: {
    async getProgramacao () {
      try {
        this.loading = true
        this.programacao = (await getProgramacao(this.pedido.numPedido))
          .map(x => {
            if (!x.situacao) x.situacao = ''
            return x
          })
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível retornar o extrato. Tente mais tarde.'
        })
      } finally {
        this.loading = false
      }
    },

    getColorVariantFromSituation (situation = '') {
      if (situation.match(/autorizad(a|o)/im)) return 'success'
      if (situation.match(/agendad(a|o)/im)) return 'warning'
      if (situation.match(/cancelad(a|o)/im)) return 'danger'
      return ''
    },

    print () {
      // this.$htmlToPaper('printMe')
      this.$htmlToPaper('printMe')
    }
  },
  computed: {},
  components: {
    ReportProgramacao
  }
}
</script>

<style lang="sass">
.my-sticky-virtscroll-table
  /* height or max-height is important */
  height: 750px

.q-table__top,
.q-table__bottom,
thead tr:first-child th /* bg color is important for th; just specify one */
  background-color: #fff

thead tr th
  position: sticky
  z-index: 1
/* this will be the loading indicator */
thead tr:last-child th
  /* height of all previous header rows */
  top: 48px
thead tr:first-child th
  top: 0
</style>